import {
	IInitialFormData,
	TEditGameCategoryVisibleForm,
	TTypeOfEditGameCategoryModalWindow,
} from './editGameCategoryContext';
import { IItemForGetShortInfo, TLanguageIDs, IUpdateGameCategory, IGameCategoryTranslation } from 'types';

export enum EditGameCategoryActionTypes {
	REFETCH_DATA = 'REFETCH_DATA',
	SET_INITIAL_FORM_DATA = 'SET_INITIAL_FORM_DATA',
	SET_ALL_DATA = 'SET_ALL_DATA',
	CHANGE_VISIBLE_FORM = 'CHANGE_VISIBLE_FORM',
	CHANGE_NAME = 'CHANGE_NAME',
	SET_FETCHED_LANGUAGES = 'SET_FETCHED_LANGUAGES',
	SET_IDs_LANGUAGES = 'SET_IDs_LANGUAGES',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	SET_TRANSLATION_TAB = 'SET_TRANSLATION_TAB',
	SET_TRANSLATION_FIELDS = 'SET_TRANSLATION_FIELDS',
	CHANGE_TRANSLATION = 'CHANGE_TRANSLATION',
	RESET_FIELDS = 'RESET_FIELDS',
}

interface IRefetchData {
	type: EditGameCategoryActionTypes.REFETCH_DATA;
	payload: {
		needRefetch: boolean;
	};
}

interface ISetInitialFormData {
	type: EditGameCategoryActionTypes.SET_INITIAL_FORM_DATA;
	payload: {
		initialFormData: IInitialFormData;
	};
}

interface ISetAllData {
	type: EditGameCategoryActionTypes.SET_ALL_DATA;
	payload: {
		categoryID: string;
		name: string;
		IDsSelectedLanguages: TLanguageIDs[];
		translations: IGameCategoryTranslation[];
	};
}

interface IChangeVisibleForm {
	type: EditGameCategoryActionTypes.CHANGE_VISIBLE_FORM;
	payload: {
		visibleForm: TEditGameCategoryVisibleForm;
	};
}

interface IChangeName {
	type: EditGameCategoryActionTypes.CHANGE_NAME;
	payload: {
		name: string;
	};
}

interface ISetFetchedLanguages {
	type: EditGameCategoryActionTypes.SET_FETCHED_LANGUAGES;
	payload: {
		languages: IItemForGetShortInfo[];
	};
}

interface ISetIDsLanguages {
	type: EditGameCategoryActionTypes.SET_IDs_LANGUAGES;
	payload: {
		IDsLanguages: TLanguageIDs[];
	};
}

interface ISetDataForSubmit {
	type: EditGameCategoryActionTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		data: IUpdateGameCategory | null;
	};
}

interface IChangeTypeOfModalWindow {
	type: EditGameCategoryActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: TTypeOfEditGameCategoryModalWindow;
	};
}

interface ISetTranslationTab {
	type: EditGameCategoryActionTypes.SET_TRANSLATION_TAB;
	payload: {
		translationTab: TLanguageIDs | null;
	};
}

interface ISetTranslationFields {
	type: EditGameCategoryActionTypes.SET_TRANSLATION_FIELDS;
	payload: {
		updatedTranslations: IGameCategoryTranslation[];
	};
}

interface IChangeTranslation {
	type: EditGameCategoryActionTypes.CHANGE_TRANSLATION;
	payload: {
		updatedTranslations: IGameCategoryTranslation[];
	};
}

interface IResetSelectedControls {
	type: EditGameCategoryActionTypes.RESET_FIELDS;
}

export type TEditGameCategoryAction =
	| IRefetchData
	| ISetInitialFormData
	| ISetAllData
	| IChangeVisibleForm
	| IChangeName
	| ISetFetchedLanguages
	| ISetIDsLanguages
	| ISetDataForSubmit
	| IChangeTypeOfModalWindow
	| ISetTranslationTab
	| ISetTranslationFields
	| IChangeTranslation
	| IResetSelectedControls;
